import { useQuery } from '@tanstack/react-query'
import { AxiosResponse } from 'axios'

import { getCardTransactionDetails } from '@src/api'
import {
  DefaultApiGetCardTransactionDetailsRequest,
  GetCardTransactionDetails200Response,
} from '@src/api/generated/user-api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'
import { CustomError } from '@src/types'

export const useFetchCardTransactionDetails = (
  params: DefaultApiGetCardTransactionDetailsRequest
) => {
  const { axiosInstance } = useAxios()

  return useQuery<
    AxiosResponse<GetCardTransactionDetails200Response>,
    AxiosResponse<CustomError>
  >({
    enabled: !!params.organizationId && !!params.visaTransactionReferenceId,
    queryFn: () => getCardTransactionDetails(axiosInstance, params),
    queryKey: [
      REACT_QUERY_CACHE_KEYS.GET_CARD_TRANSACTION_DETAILS,
      [params.organizationId, params.visaTransactionReferenceId],
    ],
  })
}
